import PrivacyRoute from "../../components/routes/PrivacyRoute";
import messages from "../../i18n/messages/de.json";

export default function Page() {
  return <PrivacyRoute locale="de" messages={messages} />;
}
